import Dashboard from "./js/Dashboard";
export default Dashboard;
